module.exports = __webpack_public_path__ + "img/logo.48784681.png";